import { render, staticRenderFns } from "./AssignmentVisualization.vue?vue&type=template&id=64bb9079&scoped=true&"
import script from "./AssignmentVisualization.vue?vue&type=script&lang=js&"
export * from "./AssignmentVisualization.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentVisualization.vue?vue&type=style&index=0&id=64bb9079&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bb9079",
  null
  
)

export default component.exports